export const MEMBER_T = {
  fr: {
    sim: {
      s1t: "Où en êtes-vous aujourd'hui ?",
      s1o1: ["Étudiant·e ou sans activité", "Je prépare mon entrée dans la vie professionnelle"],
      s1o2: ["En poste", "Je travaille et je veux progresser"],
      s1o3: ["En transition", "Je change de cap ou recherche un poste"],
      s1o4: ["Retraité·e ou proche", "J'entre dans la vraie vie"],
      s2t: "Quelle est votre expérience professionnelle ?",
      s2o1: ["Moins d'un an", "Je débute tout juste"],
      s2o2: ["1 à 3 ans", "Mes premières années"],
      s2o3: ["4 à 5 ans", "Une expertise en consolidation"],
      s2o4: ["5 à 7 ans", "Un parcours affirmé"],
      s2o5: ["7 à 12 ans", "Une trajectoire de leader"],
      s2o6: ["12 ans et plus", "Une carrière accomplie"],
      s3t: "Quel est votre niveau de responsabilité ?",
      s3o1: ["Contributif individuel", "Je n'encadre pas encore"],
      s3o2: ["Encadrement d'équipe", "Je manage des collaborateurs"],
      s3o3: ["Direction", "Je porte une direction ou un périmètre"],
      s3o4: ["Membre de COMEX", "CEO, CFO, COO ou équivalent"],
      s4t: "Quelle est votre ambition prioritaire ?",
      s4o1: ["Me découvrir", "Comprendre mes forces et mes envies"],
      s4o2: ["Progresser", "Monter en compétence et en responsabilité"],
      s4o3: ["Diriger", "Prendre la tête d'une équipe ou d'une entreprise"],
      s4o4: ["Transmettre", "Mentorer et laisser une empreinte"],
      step: "Étape", back: "Étape précédente", loading: "Nous étudions votre trajectoire…",
      resultOver: "Votre échelon recommandé", subscribe: "Souscrire", activate: "Activer le module",
      registerCta: "Créer mon espace et souscrire", restart: "Refaire le test", perMonth: "/ mois",
    },
    test: {
      question: "Question", back: "Question précédente", prep: "Préparation du test…",
      resultOver: "Votre bilan de positionnement", dominant: "Votre force dominante :",
      espaceCta: "Retrouver ce bilan dans mon espace", restart: "Refaire le test",
      adapted: "Bilan {m} — adapté à votre échelon",
      scale: ["Pas du tout", "Plutôt non", "Moyennement", "Plutôt oui", "Tout à fait"],
      dims: { vision: "Vision", autorite: "Autorité", vertu: "Vertu", audace: "Audace", vie: "Vie" },
      q: {
        q1: "Je sais où je veux être professionnellement dans cinq ans.",
        q2: "Mes choix de carrière obéissent à une direction claire que j'ai moi-même fixée.",
        q3: "On me sollicite naturellement pour trancher ou arbitrer.",
        q4: "Je sais faire entendre ma position, même face à des interlocuteurs plus seniors.",
        q5: "Je refuse les raccourcis contraires à mes valeurs, même quand ils rapporteraient.",
        q6: "Mes collaborateurs me feraient confiance les yeux fermés.",
        q7: "J'ose proposer des idées qui bousculent les habitudes de mon organisation.",
        q8: "Face à une opportunité incertaine, j'avance plutôt que j'attends.",
        q9: "Ma vie professionnelle nourrit mon épanouissement personnel, et inversement.",
        q10: "Je pense déjà à ce que je transmettrai aux générations qui suivent.",
      },
    },
    auth: {
      welcomeBack: "Bon retour", createSpace: "Créer votre espace",
      subLogin: "Retrouvez votre dossier de vie professionnelle.",
      subRegister: "Quelques secondes suffisent pour rejoindre VAV.",
      tabLogin: "Connexion", tabRegister: "Inscription",
      name: "Nom complet", email: "E-mail", password: "Mot de passe",
      pwdNew: "8 caractères minimum", pwdPh: "Votre mot de passe",
      submitLogin: "Me connecter", submitRegister: "Créer mon compte",
      wait: "Un instant…", backHome: "Retour au site", preselected: "Module choisi",
    },
    espace: {
      hello: "Bonjour", sub: "Votre assurance vie professionnelle, centralisée en un seul lieu.",
      offresLink: "Explorer les offres d'emploi fusionnées en temps réel",
      site: "Le site", logout: "Déconnexion", loading: "Chargement de votre espace…",
      myModule: "Mon module", loadingModule: "Chargement…",
      activeNote: "Accompagnement actif — tests et coaching à la demande inclus.",
      manage: "Gérer ou résilier mon abonnement",
      noModule: "Vous n'avez pas encore choisi votre échelon. Faites le test d'orientation ou sélectionnez directement un module.",
      ctaTest: "Faire le test d'orientation",
      dossierTitle: "Mon dossier de vie professionnelle",
      poste: "Poste actuel", postePh: "Ex. Chef de projet",
      entreprise: "Entreprise", entPh: "Ex. Maison & Cie",
      telephone: "Téléphone",
      telHint: "Utilisé pour les rappels SMS la veille de vos séances — modules Executive et CE_X.",
      objectifs: "Mes objectifs", objPh: "Où souhaitez-vous être dans un an, cinq ans ?",
      notes: "Notes personnelles", notesPh: "Repères, réflexions, éléments à partager avec votre coach…",
      save: "Enregistrer mon dossier", saving: "Enregistrement…",
      bilan: "Mon bilan",
      bilanEmpty: "Dix questions pour cartographier vos cinq forces — Vision, Autorité, Vertu, Audace, Vie — et éclairer votre accompagnement.",
      bilanCta: "Faire mon bilan", dominant: "Force dominante", retest: "Refaire le test",
      coaching: "Coaching à la demande",
      coachingSub: "Réservez un créneau d'une heure avec votre coach — chaque mardi et jeudi.",
      step1: "1. Choisissez un jour", step2: "2. Choisissez un horaire", step3: "3. Votre sujet",
      topicPh: "Ex. Préparer un entretien annuel décisif…", book: "Réserver ce créneau",
    },
  },
  en: {
    sim: {
      s1t: "Where do you stand today?",
      s1o1: ["Student or not yet working", "Preparing my entry into working life"],
      s1o2: ["Employed", "I work and want to grow"],
      s1o3: ["In transition", "Changing direction or seeking a role"],
      s1o4: ["Retired or nearly", "Entering true life"],
      s2t: "How much professional experience do you have?",
      s2o1: ["Less than a year", "Just starting out"],
      s2o2: ["1 to 3 years", "My first years"],
      s2o3: ["4 to 5 years", "Consolidating expertise"],
      s2o4: ["5 to 7 years", "An established track record"],
      s2o5: ["7 to 12 years", "A leader's trajectory"],
      s2o6: ["12 years and more", "An accomplished career"],
      s3t: "What is your level of responsibility?",
      s3o1: ["Individual contributor", "No direct reports yet"],
      s3o2: ["Team management", "I manage people"],
      s3o3: ["Executive leadership", "I own a function or a scope"],
      s3o4: ["Executive committee member", "CEO, CFO, COO or equivalent"],
      s4t: "What is your priority ambition?",
      s4o1: ["Discover myself", "Understand my strengths and aspirations"],
      s4o2: ["Grow", "Step up in skills and responsibility"],
      s4o3: ["Lead", "Take the helm of a team or a company"],
      s4o4: ["Pass on", "Mentor and leave a mark"],
      step: "Step", back: "Previous step", loading: "Studying your trajectory…",
      resultOver: "Your recommended level", subscribe: "Subscribe", activate: "Activate the module",
      registerCta: "Create my space and subscribe", restart: "Take the test again", perMonth: "/ month",
    },
    test: {
      question: "Question", back: "Previous question", prep: "Preparing the test…",
      resultOver: "Your positioning assessment", dominant: "Your dominant strength:",
      espaceCta: "Find this assessment in my space", restart: "Take the test again",
      adapted: "{m} assessment — tailored to your level",
      scale: ["Not at all", "Rather not", "Moderately", "Mostly", "Absolutely"],
      dims: { vision: "Vision", autorite: "Authority", vertu: "Virtue", audace: "Boldness", vie: "Life" },
      q: {
        q1: "I know where I want to be professionally in five years.",
        q2: "My career choices follow a clear direction I set for myself.",
        q3: "People naturally turn to me to decide or arbitrate.",
        q4: "I can make my position heard, even with more senior counterparts.",
        q5: "I refuse shortcuts that go against my values, even when they would pay off.",
        q6: "My colleagues would trust me blindly.",
        q7: "I dare to propose ideas that shake up my organisation's habits.",
        q8: "Facing an uncertain opportunity, I move forward rather than wait.",
        q9: "My professional life nourishes my personal fulfilment, and vice versa.",
        q10: "I already think about what I will pass on to the generations that follow.",
      },
    },
    auth: {
      welcomeBack: "Welcome back", createSpace: "Create your space",
      subLogin: "Find your professional life file.",
      subRegister: "A few seconds are enough to join VAV.",
      tabLogin: "Log in", tabRegister: "Sign up",
      name: "Full name", email: "Email", password: "Password",
      pwdNew: "8 characters minimum", pwdPh: "Your password",
      submitLogin: "Log me in", submitRegister: "Create my account",
      wait: "One moment…", backHome: "Back to the site", preselected: "Chosen module",
    },
    espace: {
      hello: "Hello", sub: "Your professional life insurance, centralised in one place.",
      offresLink: "Explore job offers merged in real time",
      site: "The site", logout: "Log out", loading: "Loading your space…",
      myModule: "My module", loadingModule: "Loading…",
      activeNote: "Active support — assessments and on-demand coaching included.",
      manage: "Manage or cancel my subscription",
      noModule: "You haven't chosen your level yet. Take the orientation test or select a module directly.",
      ctaTest: "Take the orientation test",
      dossierTitle: "My professional life file",
      poste: "Current position", postePh: "E.g. Project manager",
      entreprise: "Company", entPh: "E.g. Maison & Co",
      telephone: "Phone",
      telHint: "Used for SMS reminders the day before your sessions — Executive and CE_X modules.",
      objectifs: "My goals", objPh: "Where do you want to be in one year, five years?",
      notes: "Personal notes", notesPh: "Bearings, thoughts, points to share with your coach…",
      save: "Save my file", saving: "Saving…",
      bilan: "My assessment",
      bilanEmpty: "Ten questions to map your five strengths — Vision, Authority, Virtue, Boldness, Life — and enlighten your coaching.",
      bilanCta: "Take my assessment", dominant: "Dominant strength", retest: "Retake the test",
      coaching: "On-demand coaching",
      coachingSub: "Book a one-hour slot with your coach — every Tuesday and Thursday.",
      step1: "1. Choose a day", step2: "2. Choose a time", step3: "3. Your topic",
      topicPh: "E.g. Preparing a decisive annual review…", book: "Book this slot",
    },
  },
  de: {
    sim: {
      s1t: "Wo stehen Sie heute?",
      s1o1: ["Studierend oder ohne Beschäftigung", "Ich bereite meinen Berufseinstieg vor"],
      s1o2: ["Berufstätig", "Ich arbeite und will mich weiterentwickeln"],
      s1o3: ["Im Übergang", "Ich wechsle die Richtung oder suche eine Stelle"],
      s1o4: ["Im Ruhestand oder kurz davor", "Ich trete in das wahre Leben ein"],
      s2t: "Wie viel Berufserfahrung haben Sie?",
      s2o1: ["Weniger als ein Jahr", "Ich fange gerade an"],
      s2o2: ["1 bis 3 Jahre", "Meine ersten Jahre"],
      s2o3: ["4 bis 5 Jahre", "Expertise im Aufbau"],
      s2o4: ["5 bis 7 Jahre", "Eine gefestigte Laufbahn"],
      s2o5: ["7 bis 12 Jahre", "Eine Führungslaufbahn"],
      s2o6: ["12 Jahre und mehr", "Eine erfolgreiche Karriere"],
      s3t: "Welche Verantwortung tragen Sie?",
      s3o1: ["Einzelbeitrag", "Noch keine Führungsverantwortung"],
      s3o2: ["Teamführung", "Ich führe Mitarbeitende"],
      s3o3: ["Leitung", "Ich trage eine Funktion oder einen Bereich"],
      s3o4: ["Vorstandsmitglied", "CEO, CFO, COO oder vergleichbar"],
      s4t: "Was ist Ihr vorrangiges Ziel?",
      s4o1: ["Mich entdecken", "Meine Stärken und Wünsche verstehen"],
      s4o2: ["Wachsen", "Kompetenzen und Verantwortung ausbauen"],
      s4o3: ["Führen", "Die Leitung eines Teams oder Unternehmens übernehmen"],
      s4o4: ["Weitergeben", "Mentoring geben und ein Vermächtnis hinterlassen"],
      step: "Schritt", back: "Vorheriger Schritt", loading: "Wir prüfen Ihren Werdegang…",
      resultOver: "Ihre empfohlene Stufe", subscribe: "Abonnieren", activate: "Modul aktivieren",
      registerCta: "Mein Konto erstellen und abonnieren", restart: "Test wiederholen", perMonth: "/ Monat",
    },
    test: {
      question: "Frage", back: "Vorherige Frage", prep: "Test wird vorbereitet…",
      resultOver: "Ihre Standortbestimmung", dominant: "Ihre dominante Stärke:",
      espaceCta: "Diese Auswertung in meinem Bereich finden", restart: "Test wiederholen",
      adapted: "{m}-Auswertung — auf Ihre Stufe zugeschnitten",
      scale: ["Überhaupt nicht", "Eher nicht", "Mittelmäßig", "Eher ja", "Absolut"],
      dims: { vision: "Vision", autorite: "Autorität", vertu: "Tugend", audace: "Kühnheit", vie: "Leben" },
      q: {
        q1: "Ich weiß, wo ich in fünf Jahren beruflich stehen will.",
        q2: "Meine Karriereentscheidungen folgen einer klaren, von mir selbst gesetzten Richtung.",
        q3: "Man wendet sich von Natur aus an mich, um zu entscheiden oder zu schlichten.",
        q4: "Ich kann meine Position durchsetzen, auch gegenüber erfahreneren Gesprächspartnern.",
        q5: "Ich lehne Abkürzungen ab, die meinen Werten widersprechen, auch wenn sie sich lohnen würden.",
        q6: "Meine Mitarbeitenden würden mir blind vertrauen.",
        q7: "Ich wage es, Ideen vorzuschlagen, die die Gewohnheiten meiner Organisation aufbrechen.",
        q8: "Bei einer unsicheren Gelegenheit gehe ich voran, statt zu warten.",
        q9: "Mein Berufsleben nährt meine persönliche Entfaltung — und umgekehrt.",
        q10: "Ich denke bereits darüber nach, was ich den nachfolgenden Generationen hinterlasse.",
      },
    },
    auth: {
      welcomeBack: "Willkommen zurück", createSpace: "Ihren Bereich erstellen",
      subLogin: "Finden Sie Ihre berufliche Lebensakte.",
      subRegister: "Wenige Sekunden genügen, um VAV beizutreten.",
      tabLogin: "Anmelden", tabRegister: "Registrieren",
      name: "Vollständiger Name", email: "E-Mail", password: "Passwort",
      pwdNew: "Mindestens 8 Zeichen", pwdPh: "Ihr Passwort",
      submitLogin: "Anmelden", submitRegister: "Mein Konto erstellen",
      wait: "Einen Moment…", backHome: "Zurück zur Website", preselected: "Gewähltes Modul",
    },
    espace: {
      hello: "Hallo", sub: "Ihre berufliche Lebensversicherung, zentral an einem Ort.",
      offresLink: "Entdecken Sie in Echtzeit zusammengeführte Stellenangebote",
      site: "Zur Website", logout: "Abmelden", loading: "Ihr Bereich wird geladen…",
      myModule: "Mein Modul", loadingModule: "Wird geladen…",
      activeNote: "Aktive Begleitung — Tests und Coaching auf Abruf inklusive.",
      manage: "Mein Abonnement verwalten oder kündigen",
      noModule: "Sie haben Ihre Stufe noch nicht gewählt. Machen Sie den Orientierungstest oder wählen Sie direkt ein Modul.",
      ctaTest: "Orientierungstest machen",
      dossierTitle: "Meine berufliche Lebensakte",
      poste: "Aktuelle Position", postePh: "Z. B. Projektleiter",
      entreprise: "Unternehmen", entPh: "Z. B. Maison & Co",
      telephone: "Telefon",
      telHint: "Wird für SMS-Erinnerungen am Tag vor Ihren Sitzungen verwendet — Module Executive und CE_X.",
      objectifs: "Meine Ziele", objPh: "Wo möchten Sie in einem Jahr, in fünf Jahren stehen?",
      notes: "Persönliche Notizen", notesPh: "Anhaltspunkte, Gedanken, Punkte für Ihren Coach…",
      save: "Meine Akte speichern", saving: "Wird gespeichert…",
      bilan: "Meine Auswertung",
      bilanEmpty: "Zehn Fragen, um Ihre fünf Stärken zu kartieren — Vision, Autorität, Tugend, Kühnheit, Leben — und Ihre Begleitung zu erhellen.",
      bilanCta: "Meine Auswertung machen", dominant: "Dominante Stärke", retest: "Test wiederholen",
      coaching: "Coaching auf Abruf",
      coachingSub: "Buchen Sie eine einstündige Sitzung mit Ihrem Coach — jeden Dienstag und Donnerstag.",
      step1: "1. Wählen Sie einen Tag", step2: "2. Wählen Sie eine Uhrzeit", step3: "3. Ihr Thema",
      topicPh: "Z. B. Ein entscheidendes Jahresgespräch vorbereiten…", book: "Diesen Termin buchen",
    },
  },
  es: {
    sim: {
      s1t: "¿Dónde se encuentra hoy?",
      s1o1: ["Estudiante o sin actividad", "Preparo mi entrada en la vida profesional"],
      s1o2: ["En puesto", "Trabajo y quiero progresar"],
      s1o3: ["En transición", "Cambio de rumbo o busco un puesto"],
      s1o4: ["Jubilado o casi", "Entro en la vida verdadera"],
      s2t: "¿Cuál es su experiencia profesional?",
      s2o1: ["Menos de un año", "Acabo de empezar"],
      s2o2: ["1 a 3 años", "Mis primeros años"],
      s2o3: ["4 a 5 años", "Una experiencia en consolidación"],
      s2o4: ["5 a 7 años", "Una trayectoria afirmada"],
      s2o5: ["7 a 12 años", "Una trayectoria de líder"],
      s2o6: ["12 años y más", "Una carrera consumada"],
      s3t: "¿Cuál es su nivel de responsabilidad?",
      s3o1: ["Contribución individual", "Aún no dirijo"],
      s3o2: ["Dirección de equipo", "Gestiono colaboradores"],
      s3o3: ["Dirección", "Asumo una dirección o un perímetro"],
      s3o4: ["Miembro de COMEX", "CEO, CFO, COO o equivalente"],
      s4t: "¿Cuál es su ambición prioritaria?",
      s4o1: ["Descubrirme", "Comprender mis fuerzas y deseos"],
      s4o2: ["Progresar", "Crecer en competencia y responsabilidad"],
      s4o3: ["Dirigir", "Tomar las riendas de un equipo o empresa"],
      s4o4: ["Transmitir", "Mentorar y dejar huella"],
      step: "Etapa", back: "Etapa anterior", loading: "Estamos estudiando su trayectoria…",
      resultOver: "Su peldaño recomendado", subscribe: "Suscribirse", activate: "Activar el módulo",
      registerCta: "Crear mi espacio y suscribirme", restart: "Repetir el test", perMonth: "/ mes",
    },
    test: {
      question: "Pregunta", back: "Pregunta anterior", prep: "Preparación del test…",
      resultOver: "Su balance de posicionamiento", dominant: "Su fuerza dominante:",
      espaceCta: "Ver este balance en mi espacio", restart: "Repetir el test",
      adapted: "Balance {m} — adaptado a su nivel",
      scale: ["Para nada", "Más bien no", "Moderadamente", "Más bien sí", "Totalmente"],
      dims: { vision: "Visión", autorite: "Autoridad", vertu: "Virtud", audace: "Audacia", vie: "Vida" },
      q: {
        q1: "Sé dónde quiero estar profesionalmente dentro de cinco años.",
        q2: "Mis decisiones de carrera obedecen a una dirección clara que yo mismo fijé.",
        q3: "Se me solicita naturalmente para decidir o arbitrar.",
        q4: "Sé hacer oír mi posición, incluso ante interlocutores más veteranos.",
        q5: "Rechazo los atajos contrarios a mis valores, aunque reportaran beneficios.",
        q6: "Mis colaboradores confiarían en mí con los ojos cerrados.",
        q7: "Me atrevo a proponer ideas que sacuden los hábitos de mi organización.",
        q8: "Ante una oportunidad incierta, avanzo en lugar de esperar.",
        q9: "Mi vida profesional alimenta mi realización personal, y viceversa.",
        q10: "Ya pienso en lo que transmitiré a las generaciones siguientes.",
      },
    },
    auth: {
      welcomeBack: "Bienvenido de nuevo", createSpace: "Crear su espacio",
      subLogin: "Encuentre su expediente de vida profesional.",
      subRegister: "Unos segundos bastan para unirse a VAV.",
      tabLogin: "Iniciar sesión", tabRegister: "Registrarse",
      name: "Nombre completo", email: "E-mail", password: "Contraseña",
      pwdNew: "8 caracteres mínimo", pwdPh: "Su contraseña",
      submitLogin: "Conectarme", submitRegister: "Crear mi cuenta",
      wait: "Un momento…", backHome: "Volver al sitio", preselected: "Módulo elegido",
    },
    espace: {
      hello: "Hola", sub: "Su seguro de vida profesional, centralizado en un solo lugar.",
      offresLink: "Explorar las ofertas de empleo fusionadas en tiempo real",
      site: "El sitio", logout: "Cerrar sesión", loading: "Cargando su espacio…",
      myModule: "Mi módulo", loadingModule: "Cargando…",
      activeNote: "Acompañamiento activo — tests y coaching a la carta incluidos.",
      manage: "Gestionar o cancelar mi suscripción",
      noModule: "Aún no ha elegido su peldaño. Haga el test de orientación o seleccione directamente un módulo.",
      ctaTest: "Hacer el test de orientación",
      dossierTitle: "Mi expediente de vida profesional",
      poste: "Puesto actual", postePh: "Ej. Jefe de proyecto",
      entreprise: "Empresa", entPh: "Ej. Maison & Cía",
      telephone: "Teléfono",
      telHint: "Se usa para los recordatorios SMS la víspera de sus sesiones — módulos Executive y CE_X.",
      objectifs: "Mis objetivos", objPh: "¿Dónde quiere estar dentro de un año, de cinco años?",
      notes: "Notas personales", notesPh: "Referencias, reflexiones, elementos para compartir con su coach…",
      save: "Guardar mi expediente", saving: "Guardando…",
      bilan: "Mi balance",
      bilanEmpty: "Diez preguntas para cartografiar sus cinco fuerzas — Visión, Autoridad, Virtud, Audacia, Vida — e iluminar su acompañamiento.",
      bilanCta: "Hacer mi balance", dominant: "Fuerza dominante", retest: "Repetir el test",
      coaching: "Coaching a la carta",
      coachingSub: "Reserve una sesión de una hora con su coach — cada martes y jueves.",
      step1: "1. Elija un día", step2: "2. Elija un horario", step3: "3. Su tema",
      topicPh: "Ej. Preparar una entrevista anual decisiva…", book: "Reservar esta sesión",
    },
  },
  it: {
    sim: {
      s1t: "A che punto siete oggi?",
      s1o1: ["Studente o senza attività", "Preparo il mio ingresso nella vita professionale"],
      s1o2: ["In attività", "Lavoro e voglio progredire"],
      s1o3: ["In transizione", "Cambio rotta o cerco un posto"],
      s1o4: ["In pensione o quasi", "Entro nella vita vera"],
      s2t: "Qual è la vostra esperienza professionale?",
      s2o1: ["Meno di un anno", "Ho appena iniziato"],
      s2o2: ["Da 1 a 3 anni", "I miei primi anni"],
      s2o3: ["Da 4 a 5 anni", "Un'esperienza in consolidamento"],
      s2o4: ["Da 5 a 7 anni", "Un percorso affermato"],
      s2o5: ["Da 7 a 12 anni", "Una traiettoria da leader"],
      s2o6: ["12 anni e più", "Una carriera compiuta"],
      s3t: "Qual è il vostro livello di responsabilità?",
      s3o1: ["Contributo individuale", "Non guido ancora"],
      s3o2: ["Gestione di team", "Gestisco collaboratori"],
      s3o3: ["Direzione", "Porto una direzione o un perimetro"],
      s3o4: ["Membro di COMEX", "CEO, CFO, COO o equivalente"],
      s4t: "Qual è la vostra ambizione prioritaria?",
      s4o1: ["Scoprirmi", "Comprendere le mie forze e i miei desideri"],
      s4o2: ["Progredire", "Crescere in competenza e responsabilità"],
      s4o3: ["Guidare", "Prendere la guida di un team o di un'azienda"],
      s4o4: ["Trasmettere", "Fare mentoring e lasciare un'impronta"],
      step: "Fase", back: "Fase precedente", loading: "Stiamo studiando il vostro percorso…",
      resultOver: "Il vostro gradino consigliato", subscribe: "Abbonati", activate: "Attiva il modulo",
      registerCta: "Crea il mio spazio e abbonati", restart: "Rifare il test", perMonth: "/ mese",
    },
    test: {
      question: "Domanda", back: "Domanda precedente", prep: "Preparazione del test…",
      resultOver: "Il vostro bilancio di posizionamento", dominant: "La vostra forza dominante:",
      espaceCta: "Ritrova questo bilancio nel mio spazio", restart: "Rifare il test",
      adapted: "Bilancio {m} — su misura per il vostro livello",
      scale: ["Per niente", "Piuttosto no", "Mediamente", "Piuttosto sì", "Assolutamente"],
      dims: { vision: "Visione", autorite: "Autorità", vertu: "Virtù", audace: "Audacia", vie: "Vita" },
      q: {
        q1: "So dove voglio essere professionalmente tra cinque anni.",
        q2: "Le mie scelte di carriera obbediscono a una direzione chiara che ho fissato io stesso.",
        q3: "Mi si sollecita naturalmente per decidere o arbitrare.",
        q4: "So far sentire la mia posizione, anche di fronte a interlocutori più esperti.",
        q5: "Rifiuto le scorciatoie contrarie ai miei valori, anche se frutterebbero.",
        q6: "I miei collaboratori si fiderebbero di me a occhi chiusi.",
        q7: "Oso proporre idee che sconvolgono le abitudini della mia organizzazione.",
        q8: "Di fronte a un'opportunità incerta, avanzo invece di aspettare.",
        q9: "La mia vita professionale nutre la mia realizzazione personale, e viceversa.",
        q10: "Penso già a ciò che trasmetterò alle generazioni che seguono.",
      },
    },
    auth: {
      welcomeBack: "Bentornati", createSpace: "Create il vostro spazio",
      subLogin: "Ritrovate il vostro fascicolo di vita professionale.",
      subRegister: "Pochi secondi per entrare in VAV.",
      tabLogin: "Accedi", tabRegister: "Registrati",
      name: "Nome completo", email: "E-mail", password: "Password",
      pwdNew: "Minimo 8 caratteri", pwdPh: "La vostra password",
      submitLogin: "Accedi", submitRegister: "Crea il mio account",
      wait: "Un attimo…", backHome: "Torna al sito", preselected: "Modulo scelto",
    },
    espace: {
      hello: "Buongiorno", sub: "La vostra assicurazione sulla vita professionale, centralizzata in un unico luogo.",
      offresLink: "Esplora le offerte di lavoro fuse in tempo reale",
      site: "Il sito", logout: "Esci", loading: "Caricamento del vostro spazio…",
      myModule: "Il mio modulo", loadingModule: "Caricamento…",
      activeNote: "Accompagnamento attivo — test e coaching su richiesta inclusi.",
      manage: "Gestisci o annulla il mio abbonamento",
      noModule: "Non avete ancora scelto il vostro gradino. Fate il test di orientamento o selezionate direttamente un modulo.",
      ctaTest: "Fare il test di orientamento",
      dossierTitle: "Il mio fascicolo di vita professionale",
      poste: "Posizione attuale", postePh: "Es. Project manager",
      entreprise: "Azienda", entPh: "Es. Maison & C.",
      telephone: "Telefono",
      telHint: "Usato per i promemoria SMS il giorno prima delle sessioni — moduli Executive e CE_X.",
      objectifs: "I miei obiettivi", objPh: "Dove volete essere tra un anno, tra cinque anni?",
      notes: "Note personali", notesPh: "Riferimenti, riflessioni, elementi da condividere con il vostro coach…",
      save: "Salva il mio fascicolo", saving: "Salvataggio…",
      bilan: "Il mio bilancio",
      bilanEmpty: "Dieci domande per mappare le vostre cinque forze — Visione, Autorità, Virtù, Audacia, Vita — e illuminare il vostro accompagnamento.",
      bilanCta: "Fare il mio bilancio", dominant: "Forza dominante", retest: "Rifare il test",
      coaching: "Coaching su richiesta",
      coachingSub: "Prenotate una sessione di un'ora con il vostro coach — ogni martedì e giovedì.",
      step1: "1. Scegliete un giorno", step2: "2. Scegliete un orario", step3: "3. Il vostro tema",
      topicPh: "Es. Preparare un colloquio annuale decisivo…", book: "Prenota questa sessione",
    },
  },
};
